/* 🤖 this file was generated by script */
export const wsolidiconTool01 = {
  name: 'tool_01',
  data: `<svg viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M9 8a7 7 0 0 1 9.35-6.6 1 1 0 0 1 .37 1.65l-2.24 2.27a3 3 0 0 0-.55.66 1 1 0 0 0 0 .78c.08.18.24.34.56.66s.48.48.66.56c.24.1.53.1.78 0 .18-.08.34-.24.66-.56l2.3-2.29a1 1 0 0 1 1.64.35A6.98 6.98 0 0 1 16 15q-.86 0-1.66-.2l-.6-.12-.29.28-6.24 6.25a3.12 3.12 0 1 1-4.42-4.42l6.25-6.24q.2-.21.28-.3.02-.02 0-.06l-.12-.53A7 7 0 0 1 9 8" clip-rule="evenodd"/></svg>`,
  iconStyle: 'solid',
};
